import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import userManager from "./userManager";
import PropTypes from 'prop-types';

class CallbackPage extends React.Component {

    constructor(props) {
        super(props);
        this.handleCallback = this.handleCallback.bind(this);
    }

    handleCallback = (user) => {
        const {router} = this.props; 
        router.push(user.state.redirectUrl);
    }

    render() {
        // just redirect to '/' in both cases
        return (
            <CallbackComponent userManager={userManager} successCallback={this.handleCallback} errorCallback={this.handleCallback}>
                <div></div>
            </CallbackComponent>
        );
    }
}

CallbackPage.propTypes = {
    router: PropTypes.object.isRequired
};

export default connect()(CallbackPage);


// WEBPACK FOOTER //
// ./src/oidc/CallbackPage.js